const compareDOMPosition = (a, b) => {
  return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
};
const getElementsFromSelector = selector => {
  const elements = document.querySelectorAll(selector);
  return Array.from(elements);
};
export const sortResultsByDOMOrder = results => {
  const sortedResults = results.sort((a, b) => {
    const elementA = getElementsFromSelector(a.selector)[0];
    const elementB = getElementsFromSelector(b.selector)[0];
    return compareDOMPosition(elementA, elementB);
  });
  return sortedResults;
};